<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/survey/survey_complete_add')"
      >添加</el-button
    >
    <el-button
      size="medium"
      type="info"
      @click="downloadFile()"
      style="margin-bottom: 5px"
      v-if="roles.includes('/equipment/template')"
      >下载问卷模板</el-button
    >
    <el-button
      size="medium"
      type="success"
      @click="leadIn('/survey/survey_info_input')"
      style="margin-bottom: 5px"
      v-if="roles.includes('/equipment/import')"
      >导入问卷</el-button
    >
    <el-button
      size="medium"
      type="info"
      @click="downloadFileQuestion()"
      style="margin-bottom: 5px"
      v-if="roles.includes('/equipment/template')"
      >下载问题模板</el-button
    >
    <el-button
      size="medium"
      type="success"
      @click="leadIn('/survey/survey_question_input')"
      style="margin-bottom: 5px"
      v-if="roles.includes('/equipment/import')"
      >导入问题</el-button
    >
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="标题" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="图片" width="100">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.image"
            style="width: 40px; height: 40px; margin: 0 5px 5px 0"
            :src="imageOss + scope.row.image"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.image.split(','))"
          >
          </el-image>
        </template>
      </el-table-column> -->
      <el-table-column label="描述">
        <template slot-scope="scope">
          <span>{{ scope.row.description }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="问题量" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column label="楼号">
        <template slot-scope="scope">
          <span>{{ scope.row.building }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="是否置顶">
        <template slot-scope="scope">
          {{ scope.row.top == 1 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="发布状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'danger' : 'success'"
            disable-transitions
            >{{ scope.row.status == 1 ? "暂存" : "发布" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/survey/survey_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/survey/survey_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/survey/survey_del')"
            >删除</el-button
          >
          <el-button
            style="margin: 0; margin-top: 10px"
            size="mini"
            type="primary"
            @click="getRegisterUser(scope.row.id)"
            v-if="roles.includes('/survey/survey_answer_users')"
            >参与人员列表</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="getAnswersCount(scope.row)"
            v-if="roles.includes('/survey/survey_statistics')"
            >问卷统计</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <!-- 编辑弹框 -->
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问卷主题" prop="title">
          <el-input
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入问卷主题"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            type="date"
            @change="startTimeChange"
            v-model="ruleForm.start_time"
            placeholder="开始时间"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            type="date"
            @change="endTimeChange"
            v-model="ruleForm.end_time"
            placeholder="结束时间"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="问卷封面图" prop="image">
          <el-upload
            :action="ossUpload"
            name="file[]"
            :data="{ type: 'image' }"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
            :class="fileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          >
          <div class="pic-tips">点击图片修改封面图</div>
        </el-form-item> -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="1">暂存</el-radio>
            <el-radio :label="2">发布</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否置顶" prop="top">
          <el-radio-group v-model="ruleForm.top">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="排序" prop="sort">
          <el-input
            class="w4 numInput"
            type="Number"
            v-model="ruleForm.sort"
            min="0"
            placeholder="请输入排序，越大越靠前"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入描述"
            v-model="ruleForm.description"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          label="问题"
          :rules="[{ required: true, message: '请添加问题' }]"
        >
          <div
            v-for="(item, index) in ruleForm.question"
            :key="index"
            style="margin-bottom: 20px"
            class="quesBox"
          >
            <div class="ques">
              <span>问题{{ index + 1 }}</span>
              <el-button
                class="delText"
                type="danger"
                size="mini"
                @click="quesDel(index)"
                round
                >删除问题</el-button
              >
            </div>
            <el-form-item
              :rules="[
                { required: true, message: '请选择问题类型', trigger: 'blur' },
              ]"
              class="formItem"
              label="问题题目"
              :prop="`question.${index}.question`"
            >
              <el-input
                v-model="item.question"
                placeholder="请输入问题题目"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="margin-bottom: 20px"
              label="问题类型"
              :prop="`question.${index}.type`"
              :rules="[
                {
                  required: true,
                  message: '请选择问题类型',
                  trigger: 'change',
                },
              ]"
            >
              <el-radio-group
                v-model="item.type"
                @change="
                  (val) => {
                    radioChange(val, index);
                  }
                "
              >
                <el-radio :label="1">单选题</el-radio>
                <el-radio :label="2">多选题</el-radio>
                <el-radio :label="3">填写题</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item
              class="formItem"
              label="排序"
              :prop="`question.${index}.sort`"
              :rules="[
                { required: true, message: '请输入排序', trigger: 'blur' },
              ]"
            >
              <el-input
                type="number"
                class="numInput"
                v-model="item.sort"
                placeholder="请输入排序"
                min="0"
              >
              </el-input>
            </el-form-item> -->
            <el-form-item
              class="formItem"
              label="选项"
              v-if="item.type == 1 || item.type == 2"
              :rules="[{ required: true, message: '请输入选项' }]"
            >
              <div v-for="(column, key) in item.option" :key="key">
                <div class="ques">
                  <span>选项{{ key + 1 }}</span>
                  <el-button
                    class="delText"
                    type="danger"
                    size="mini"
                    @click="quesOption(index, key)"
                    round
                    >删除选项</el-button
                  >
                </div>
                <el-form-item
                  class="formItem"
                  label="选项"
                  :prop="`question.${index}.option.${key}.option`"
                  :rules="[
                    { required: true, message: '请输入选项', trigger: 'blur' },
                  ]"
                >
                  <el-input
                    class="w4"
                    v-model="column.option"
                    placeholder="请输入选项"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  style="margin-bottom: 20px"
                  label="是否正确选项"
                  :prop="`question.${index}.option.${key}.is_true`"
                  :rules="[
                    {
                      required: true,
                      message: '请选择是否正确选项',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-radio-group v-model="column.is_true">
                    <el-radio :label="1">错误</el-radio>
                    <el-radio :label="2">正确</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- <el-form-item
                  class="formItem"
                  label="排序"
                  :prop="`question.${index}.option.${key}.sort`"
                  :rules="[
                    { required: true, message: '请输入排序', trigger: 'blur' },
                  ]"
                >
                  <el-input
                    type="number"
                    class="w4 numInput"
                    v-model="column.sort"
                    placeholder="请输入排序"
                    min="0"
                  >
                  </el-input>
                </el-form-item> -->
              </div>
              <el-button
                v-if="item.option.length < 4"
                size="small"
                type="primary"
                @click="addOption(index)"
                >添加选项</el-button
              >
            </el-form-item>
          </div>
          <el-button size="small" type="primary" @click="addQue()"
            >添加问题</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="onSubmit('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit' || czType == 'see'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="info"
            @click="resetForm('ruleForm'), (drawer = false)"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="参与人员列表" :visible.sync="dialogVisible" width="800px">
      <el-table
        v-loading="userLoading"
        :data="registerUserList"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        row-key="id"
      >
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{
              (registerUser.page - 1) * registerUser.page_size +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <el-table-column label="问卷主题">
          <template slot-scope="scope">
            <span v-if="scope.row.survey_info">
              {{ scope.row.survey_info.title }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="用户">
          <template slot-scope="scope">
            <span>{{ scope.row.user ? scope.row.user.name : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.user ? scope.row.user.phone : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="操作"
          width="120"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="answerUsersSee(scope.row)"
              v-if="roles.includes('/survey/survey_answers')"
              >查看个人答卷</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-pagination
          :page-size="registerUser.page_size"
          @current-change="registerPageChange"
          layout="prev, pager, next"
          :current-page="registerUser.page"
          :total="registerUser.total"
        >
        </el-pagination>
      </span>
    </el-dialog>
    <el-dialog title="个人答卷" :visible.sync="answersDialog" width="600px">
      <div class="answersBox" v-for="(item, index) in answersList" :key="index">
        <el-descriptions
          :title="'题目' + (index + 1) + '：' + item.question"
          :column="1"
        >
          <el-descriptions-item
            label="问题选项"
            v-if="item.type == 1 || item.type == 2"
          >
            <div v-if="item.type == 1">
              <el-radio-group disabled v-model="item.select">
                <el-radio
                  v-for="(radio, key) in item.survey_question_option"
                  :key="key"
                  :label="radio.id"
                  >{{ radio.option }}</el-radio
                >
              </el-radio-group>
            </div>
            <div v-if="item.type == 2">
              <el-checkbox-group disabled v-model="item.select">
                <el-checkbox
                  v-for="(radio, key) in item.survey_question_option"
                  :key="key"
                  :label="radio.id"
                  >{{ radio.option }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="问题填写" v-if="item.type == 3">
            {{ item.answer }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
    <el-dialog title="问卷统计" :visible.sync="statisticsDialog" width="500px">
      <el-button
        @click="derive()"
        v-if="roles.includes('/survey/survey_statistics_export')"
        type="warning"
        >统计导出</el-button
      >
      <el-table
        v-loading="statisticLoading"
        :data="statisticsList"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        row-key="id"
      >
        <el-table-column label="ID">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column label="问题名称">
          <template slot-scope="scope">
            <div class="line2">{{ scope.row.question }}</div>
          </template>
        </el-table-column>
        <el-table-column label="选项名称">
          <template slot-scope="scope">
            <div class="line2">{{ scope.row.option }}</div>
          </template>
        </el-table-column>
        <el-table-column label="选项选择数量">
          <template slot-scope="scope">
            <span>{{ scope.row.option_count }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + upUrl"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="fileHandleAvatarSuccess"
        :on-progress="fileBeforeAvatarUpload"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark, delImage } from "@/api/index";
import {
  surveyList,
  surveyDel,
  surveyEdit,
  surveyInfo,
  survey_complete_add,
  survey_answer_users,
  survey_answers,
  survey_statistics,
  survey_statistics_export,
  survey_info_template,
  survey_question_template,
} from "@/api/survey";
import { getToken } from "@/utils/auth";

export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      parkList: [],
      token: getToken(),
      ossUpload: this.$store.state.ossUpload,
      ruleForm: {
        title: "",
        image: "",
        description: "",
        start_time: "",
        end_time: "",
        status: "",
        sort: "",
        top: "",
        park_id: "",
        question: [
          {
            type: "",
            question: "",
            sort: "",
            option: [
              // {
              //   option: "",
              //   sort: "",
              //   is_true: "",
              // },
            ],
          },
        ],
      },
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        top: [{ required: true, message: "请选择是否置顶", trigger: "change" }],
        title: [{ required: true, message: "请输入主题", trigger: "blur" }],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" },
        ],
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        // image: [{ required: true, message: "请选择封面图", trigger: "blur" }],
        type: [
          { required: true, message: "请选择问题类型", trigger: "change" },
        ],
        question: [
          { required: true, message: "请输入问题题目", trigger: "blur" },
        ],
      },
      drawerTitle: "",
      czType: "",
      drawer: false,
      list: [],
      listLoading: true,
      total: 0,
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
      },
      dialogVisible: false,
      registerUserList: [],
      userLoading: false,
      registerUser: {
        survey_info_id: "",
        page: 1,
        page_size: 15,
        total: 0,
      },
      answersDialog: false,
      answersList: [],
      statisticsDialog: false,
      statisticsList: [],
      statisticLoading: false,
      infoId: "",
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      fileList: [],
      loadProgress: 0,
      progressFlag: false,
      msgData: [],
      upUrl: "",
    };
  },
  created() {
    this.fetchData();
    this.getPark();
    // this.answerUsersSee({ survey_info_id: 15, user_id: 29 });
  },
  methods: {
    startTimeChange(e) {
      if (e && this.ruleForm.end_time) {
        var start_timestamp = new Date(e.replace(/"-"/g, "/")).getTime();
        var end_timestamp = new Date(
          this.ruleForm.end_time.replace(/"-"/g, "/")
        ).getTime();
        if (start_timestamp > end_timestamp) {
          this.$message({
            type: "warning",
            message: "开始时间不能大与结束时间！",
          });
          this.ruleForm.start_time = "";
        }
      }
    },
    endTimeChange(e) {
      if (e && this.ruleForm.start_time) {
        var end_timestamp = new Date(e.replace(/"-"/g, "/")).getTime();
        var start_timestamp = new Date(
          this.ruleForm.start_time.replace(/"-"/g, "/")
        ).getTime();
        if (start_timestamp > end_timestamp) {
          this.$message({
            type: "warning",
            message: "结束时间不能小与开始时间！",
          });
          this.ruleForm.end_time = "";
        }
      }
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
    },
    // 导入
    leadIn(url) {
      this.upUrl = url;
      this.leadInVisible = true;
    },
    openDrawer() {
      this.$refs.ruleForm.clearValidate();
    },
    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 上传成功
    fileHandleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });

        this.$refs.upload.clearFiles();

        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.msgData.push(res.msg);
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    fileBeforeAvatarUpload(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 下载问卷导入模板
    downloadFile() {
      survey_info_template().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    // 下载问题导入模板
    downloadFileQuestion() {
      survey_question_template().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    // 统计导出
    derive() {
      let data = {
        survey_info_id: this.infoId,
      };
      const loading = this.$loading({
          lock: true,
          text: '数据量过大，正在导出中...',
          spinner: 'el-icon-loading'
        });
      survey_statistics_export(data).then((res) => {
        loading.close();
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = res.name;
        // downloadElement.target="_blank"
        downloadElement.setAttribute("target", "_blank");
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(error =>{
        loading.close();
      });
    },
    // 查看问卷统计
    getAnswersCount(e) {
      this.statisticLoading = true;
      this.infoId = e.id;
      let data = {
        survey_info_id: e.id,
      };
      survey_statistics(data).then((res) => {
        this.statisticLoading = false;
        this.statisticsList = res.data.list;
        this.statisticsDialog = true;
      });
    },
    // 查看个人答卷
    answerUsersSee(e) {
      let data = {
        survey_info_id: e.survey_info_id,
        user_id: e.user_id,
      };
      survey_answers(data).then((res) => {
        this.answersList = res.data.rows;
        this.answersDialog = true;
      });
    },

    // 问卷用户分页
    registerPageChange(current) {
      this.registerUser.page = current;
      this.getRegisteredList();
    },
    // 查看问卷参与人员
    getRegisterUser(survey_info_id) {
      this.userLoading = true;
      this.registerUser = {
        survey_info_id,
        page: 1,
        page_size: 15,
        total: 0,
      };
      this.getRegisteredList();
    },
    // 获取问卷参与人员
    getRegisteredList() {
      survey_answer_users(this.registerUser).then((res) => {
        this.userLoading = false;
        this.dialogVisible = true;
        this.registerUserList = res.data.rows.data;
        this.registerUser.page = res.data.rows.current_page;
        this.registerUser.total = res.data.rows.total;
      });
    },

    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          surveyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 点击编辑
    handleEdit(val) {
      this.czType = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 点击查看
    handleSee(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取问卷信息
    getInfo(id) {
      var that = this;
      surveyInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          start_time: res.data.info.start_time,
          title: res.data.info.title,
          end_time: res.data.info.end_time,
          description: res.data.info.description,
          status: res.data.info.status,
          top: res.data.info.top,
          sort: res.data.info.sort,
          image: res.data.info.image,
          question: res.data.info.question,
        };
        var list = res.data.info.image ? res.data.info.image.split(",") : [];
        // this.fileList = list.map((item) => {
        //   return {
        //     name: +new Date(),
        //     url: this.imageOss + item,
        //     response: {
        //       data: {
        //         url: item,
        //       },
        //     },
        //   };
        // });
      });
      this.$nextTick(() => {
        this.drawer = true;
      });
    },
    // 添加问卷
    addMenu(id) {
      this.drawerTitle = "添加";
      this.czType = "add";
      this.ruleForm = {
        title: "",
        image: "",
        description: "",
        start_time: "",
        end_time: "",
        status: "",
        sort: 0,
        top: "",
        park_id: "",
        question: [
          {
            type: "",
            question: "",
            sort: "",
            option: [
              // {
              //   option: "",
              //   sort: "",
              //   is_true: "",
              // },
            ],
          },
        ],
      };
      this.fileList = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },

    // 选项类型切换
    radioChange(val, index) {
      if (
        (val == 1 || val == 2) &&
        this.ruleForm.question[index].option.length < 1
      ) {
        this.ruleForm.question[index].option.push({
          option: "",
          sort: "",
          is_true: "",
        });
      }
    },
    // 删除选项
    quesOption(index, key) {
      this.ruleForm.question[index].option.splice(key, 1);
    },
    // 添加选项
    addOption(index) {
      this.ruleForm.question[index].option.push({
        option: "",
        sort: "",
        is_true: "",
      });
    },
    // 删除问题
    quesDel(index) {
      this.ruleForm.question.splice(index, 1);
    },
    // 添加问题
    addQue() {
      this.ruleForm.question.push({
        type: "",
        question: "",
        sort: "",
        option: [],
      });
    },
    // 提交添加问卷
    onSubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              survey_complete_add(this.ruleForm).then((res) => {
                that.drawer = false;
                that.fetchData();
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 提交修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              surveyEdit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    //删除方法获取到的file是被删除的file
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.image = "";
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        if (this.ruleForm.image) {
          this.delImg(this.ruleForm.image);
        }
        this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.image = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传限制
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    fetchData() {
      this.listLoading = true;
      surveyList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.ques {
  color: #409eff;
}
.delText {
  margin-left: 10px;
}
.formItem {
  margin-bottom: 10px;
}
.quesBox {
  border: 1px solid #d9d9d9;
  padding-left: 10px;
  padding-bottom: 10px;
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}

.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
::v-deep .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
